import globals from "@/styles/partials/global-variables";
import { NarrowLongBlackArrow } from "@/styles/partials/icons";
import { LinkText, NormalText } from "../partials/texts";

export default {
  container: {
    marginLeft: "15px",
    display: "flex",
    flexDirection: "column",
    marginRight: "15px",
    marginBottom: "30px",
    width: "calc(50% - 30px)",
    ...NormalText,
    [`@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)`]: {
      display: "block"
    },
    [`@media (${globals.breakpoints.$xs})`]: {
      width: "100%"
    },
    [`@media (${globals.breakpoints.$md})`]: {
      width: "calc(33% - 30px)"
    },
    "& .product-image": {
      flex: 2,
      alignItems: "center",
      justifyContent: "center",
      display: "flex",
      // height: "345px",
      marginBottom: "10px",
      "& > a": {
        display: "flex"
      },
      "& img": {
        margin: "0 auto",
        height: "100%",
        width: "100%",
        maxHeight: "345px",
        maxWidth: "345px",
        [`@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)`]: {
          maxWidth: "250px"
        }
      }
    },
    "& a.disabled": {
      cursor: "default"
    },
    "& .product-footer": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      "& .product-name": {
        ...LinkText,
        display: "block",
        fontSize: globals.fontSize.sm,
        fontWeight: "600",
        marginBottom: "10px"
      },
      "& .price": {
        color: globals.colors.gray5,
        fontSize: globals.fontSize.xs,
        marginBottom: "20px"
      },
      "& .product-button": {
        ...LinkText,
        fontSize: globals.fontSize.xs
      },
      "& .go-to-product-button": {
        borderBottom: "1px solid #000",
        paddingBottom: "2px",
        position: "relative",
        paddingRight: "20px",
        "&:after": {
          ...NarrowLongBlackArrow,
          right: "0px!important"
        }
      }
    }
  }
};
